import React from "react";
import { Grid, Typography, CardMedia } from "@mui/material";
import { size, COLORS } from "../../utils";
import styles from "./Team.module.css";

const DATA = [
  {
    Name: "Dr. J. UthayaKumar",
    Position: "Founder & CEO",
    Image: "/assets/images/gallery/img01.jpg",
  },
  {
    Name: "Dr. A. Sariga UthayaKumar",
    Position: "Managing Director",
    Image: "/assets/images/gallery/img02.webp",
  },
  {
    Name: "Mr. J. RaviKumar",
    Position: "Lead AI/ML Engineer",
    Image: "/assets/images/gallery/img03.jpg",
  },
  {
    Name: "Mrs. R. Priyanka",
    Position: "Technical Content Writer",
    Image: "/assets/images/gallery/img04.png",
  },
  {
    Name: "Mr. V. Natarajan",
    Position: "Senior Graphic Designer",
    Image: "/assets/images/gallery/img05.jpg",
  },
  {
    Name: "Mr. ArulPandi",
    Position: "Python Developer",
    Image: "/assets/images/gallery/img06.jpg",
  },
  {
    Name: "Mr. Dinesh Babu",
    Position: "Graphic Designer",
    Image: "/assets/images/gallery/img07.jpg",
  },
  {
    Name: "Miss. S. Sangeetha",
    Position: "Technical Content Writer",
    Image: "/assets/images/gallery/img08.jpg",
  },
  {
    Name: "Miss. A. Sandhiya",
    Position: "Technical Content Writer",
    Image: "/assets/images/gallery/img09.jpg",
  },
  {
    Name: "Mr. H. Abdul Kapoor",
    Position: "Full Stack Developer",
    Image: "/assets/images/gallery/img10.png",
  },
  {
    Name: "Mr. N. Ganesh",
    Position: "AI/ML Engineer",
    Image: "/assets/images/gallery/img11.jpg",
  },
  {
    Name: "Miss. T. Kaviya",
    Position: "Technical Content Writer",
    Image: "/assets/images/gallery/img12.jpg",
  },
  {
    Name: "Mr. A. Ganesh",
    Position: "AI/ML Engineer",
    Image: "/assets/images/gallery/img13.jpg",
  },
  {
    Name: "Mrs. J. Semmozhi",
    Position: "Content Writer",
    Image: "/assets/images/gallery/img14.png",
  },
  {
    Name: "Mr. M. Tholkappiyan",
    Position: "Publication Coordinator",
    Image: "/assets/images/gallery/img15.jpg",
  },
  {
    Name: "Miss. R. Saraswathy",
    Position: "Content Writer",
    Image: "/assets/images/gallery/img16.png",
  },
  {
    Name: "Mrs. Jayanthi",
    Position: "Publication Coordinator",
    Image: "/assets/images/gallery/img17.png",
  },
];

export default function Team() {
  return (
    <Grid
      item
      container
      flexWrap={"nowrap"}
      direction={"column"}
      alignItems={"center"}
      mt={size({ p: 9, h: true })}
      rowGap={size({ p: 10, h: true })}
    >
      <Grid
        item
        container
        flexWrap={"nowrap"}
        direction={"column"}
        alignItems={"center"}
        rowGap={size({ p: 2, h: true })}
      >
        <Grid item>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: size({ p: 2.2 }),
              fontWeight: 600,
              textAlign: "center",
              color: `${COLORS.C2}`,
            }}
            className={styles.toptitle}
          >
            Meet the team behind your next project_
          </Typography>
        </Grid>
        <Grid item width={size({ p: 60 })}>
          <Typography
            sx={{
              fontFamily: "Archia",
              fontSize: size({ p: 0.9 }),
              fontWeight: 500,
              textAlign: "center",
              color: `${COLORS.C1}A0`,
              padding: `0px ${size({ p: 7 })}`,
            }}
            className={styles.subtitle}
          >
            Meet the Minds Behind Genesys – The Professionals Empowering Your
            Success. With a team of experienced experts and Research-qualified
            professionals, we empower students and researchers to explore,
            learn, and excel.{" "}
          </Typography>
        </Grid>
      </Grid>
      <Grid
        item
        container
        alignItems={"center"}
        rowGap={size({ p: 5, h: true })}
        padding={`0px ${size({ p: 15 })}`}
        className={styles.cards}
      >
        {DATA.map((dat) => {
          return (
            <Grid
              item
              container
              flexWrap={"nowrap"}
              alignItems={"center"}
              justifyContent={"center"}
              direction={"column"}
              rowGap={size({ p: 1, h: true })}
              xs={3}
              className={styles.card1}
            >
              {/* Animated Border Wrapper with same size */}
              <div
                className={styles.animatedBorderWrapper}
                style={{ width: size({ p: 13 }), height: size({ p: 15 }), border: '2px solid #aaaaaa', borderRadius: '6%', overflow: "hidden" }}
              >
                <CardMedia
                  component={"img"}
                  image={dat["Image"]}
                  sx={{
                    borderRadius: '6%',
                  }}
                />
              </div>

              <Grid sx={{ mt: "15px" }}>
                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: "Archia",
                      fontSize: size({ p: 1 }),
                      fontWeight: 600,
                      textAlign: "center",
                      color: COLORS.C1,
                    }}
                    className={styles.title1}
                  >
                    {dat["Name"]}
                  </Typography>
                </Grid>

                <Grid item>
                  <Typography
                    sx={{
                      fontFamily: "Archia",
                      fontSize: size({ p: 1 }),
                      fontWeight: 400,
                      textAlign: "center",
                      color: COLORS.BLACK + "A0",
                    }}
                    className={styles.title2}
                  >
                    {dat["Position"]}
                  </Typography>
                </Grid>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );
}
